import React, { useContext, useEffect } from 'react';
import { PortfolioContext } from '../../contexts/PortfolioContext.tsx';
import PortfolioGrid from '../../components/portfolio/PortfolioGrid.tsx';

export default function PortfolioGame() {
  const portfolio = useContext(PortfolioContext);

  useEffect(() => {
    portfolio?.resetGame();
    // Fresh game when entering this view only — not when context callbacks change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!portfolio) return null;

  return (
    <div className="game-container portfolio-game">
      <div className="game-grid-area">
        <PortfolioGrid />
      </div>
    </div>
  );
}

